import script from "./retrievePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./retrievePassword.vue?vue&type=script&setup=true&lang=js"

import "./retrievePassword.vue?vue&type=style&index=0&id=084b2c80&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084b2c80"]])

export default __exports__